import type mapboxgl from 'mapbox-gl';

/**
 * Set a GeoJSON source's data, guarding the React-19-StrictMode race where the
 * map's `load` may fire after the data is ready (same guard as ParcelMap).
 */
export function setSourceData(
  map: mapboxgl.Map,
  sourceId: string,
  data: GeoJSON.FeatureCollection,
): void {
  const apply = () => {
    const src = map.getSource(sourceId) as mapboxgl.GeoJSONSource | undefined;
    if (src) src.setData(data);
  };
  if (map.getSource(sourceId)) apply();
  else map.once('load', apply);
}

export const EMPTY_FC: GeoJSON.FeatureCollection = { type: 'FeatureCollection', features: [] };
